import { render } from "./ProSupply.vue?vue&type=template&id=4dcded1c&scoped=true"
import script from "./ProSupply.vue?vue&type=script&lang=js"
export * from "./ProSupply.vue?vue&type=script&lang=js"

import "./ProSupply.vue?vue&type=style&index=0&id=4dcded1c&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dcded1c"]])

export default __exports__